export default function clearLocalStorage() {
  localStorage.removeItem("sessionId");
  localStorage.removeItem("collectedData");
  localStorage.removeItem("activeStep");
  localStorage.removeItem("title");
}
